import { savedJQuery } from './components/jquery';

let liveSearchDebounceTimer = null;
let liveSearchCurrentRequest = null;
let liveSearchLastQuery = undefined;

export function initLiveSearch () {
  const searchInput = savedJQuery('.navbar-search');
  if (!searchInput.length) {
    return;
  }
  // Ensure only one handler is bound
  savedJQuery(document).off('input.liveSearch', '.navbar-search');

  // Debounced input handler for navbar search
  savedJQuery(document).on('input.liveSearch', '.navbar-search', function () {
    const query = String(savedJQuery(this).val() || '').trim();

    if (liveSearchDebounceTimer) {
      clearTimeout(liveSearchDebounceTimer);
    }

    liveSearchDebounceTimer = setTimeout(() => {
      // Only search when cleared or when query has enough length
      if (query.length === 0 || query.length >= 2) {
        if (query === liveSearchLastQuery) {
          return; // skip duplicate
        }
        liveSearchLastQuery = query;
        fetch_customer_data(query);
      }
    }, 600);
  });

  // Initial load with empty query (shows placeholder message)
  fetch_customer_data('');
}

function fetch_customer_data (query = '') {
  // Cancel previous in-flight request
  if (liveSearchCurrentRequest && liveSearchCurrentRequest.readyState !== 4) {
    try { liveSearchCurrentRequest.abort(); } catch (e) { /* noop */ }
  }

  const aj = {
    url: "/live-search/action",
    method: 'GET',
    data: { query: query },
    dataType: 'json',
    success: function (data) {
      savedJQuery('.tbody').html(highlight2(data.table_data, query));
      savedJQuery('#total_records').text(data.total_data);
    }
  };
  liveSearchCurrentRequest = savedJQuery.ajax(aj);
}

function highlight (dataToHighlight = null, text) {
  if (dataToHighlight != null) {
    var i = 1;
    var previous = 0;
    var current = -10;
    while (i < 10 && previous > -1) {
      i += 1;

      var regex = new RegExp(text, 'i');
      current = dataToHighlight.indexOf(text, previous);
      console.log(dataToHighlight.search(regex));
      var lengthStep = 0;
      let index = current;
      if (index >= 0) {
        var strappend1 = "<i class='font-italic text-danger'>";
        var strappend2 = "</i>";
        dataToHighlight = dataToHighlight.substring(0, index)
          + strappend1
          + dataToHighlight.substring(index, index + text.length)
          + strappend2
          + dataToHighlight.substring(index + text.length);
        lengthStep = strappend1.length + strappend2.length
      }


      previous = current + lengthStep;
    }
  }
  return dataToHighlight;
}

function highlight2 (dataToHighlight = null, text) {
  if (dataToHighlight != null && text.length > 3) {
    var regex = new RegExp(text, 'gi');
    var strappend1 = "<i class='font-italic text-danger'>";
    var strappend2 = "</i>";
    var replacement = strappend1 + text + strappend2;
    dataToHighlight = dataToHighlight.replace(regex, replacement);
  }
  return dataToHighlight;
}